import {
  CONFIG_SERVICE_KEYS,
  FEATURE_DECISION_KEYS,
} from '@web-platform/shared-universal-constants-config';
import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';

import { getConfigServiceValue, getFeatureDecision, parseCsvConfigServiceValue } from '../config';

export const isExploreAIAvailable = (): boolean => {
  const enableExploreAI = getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_EXPLORE_AI);

  if (!enableExploreAI) {
    return false;
  }

  const { locale } = getCulture();
  const allowedLocales = parseCsvConfigServiceValue(
    getConfigServiceValue(CONFIG_SERVICE_KEYS.EXPERIMENT.ASK_SKYSCANNER_LOCALES_ENABLED),
  );

  return allowedLocales.includes(locale);
};
